import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedOvw202512: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_ovw_202512",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-12-01",
  endDate: "2025-12-31",
  impressions: 16047,
  clicks: 269,
  adsSpendDollars: 1290,
  budgetDollars: 15000,
  salesDollars: 14817,
  bestEstimateRoas: 11.49,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.09,
  newCustomersAcquired: 16,
  reorderConversions: 8,
  dataAvailableAtDate: "2026-01-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
